"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.theme = exports.colors = void 0;
// @ts-nocheck
const styles_1 = require("@material-ui/core/styles");
// Using our own 'colors' value because MaterialUI's 'PaletteOptions' type def doesn't allow us to add custom colors to the palette
exports.colors = {
    success: '#3B953E',
    grayPlaceholder: '#CCCCCC',
    danger: '#EB5757',
    white: '#FFFFFF',
    grayLine: '#EEEEEE',
    info: '#58C8FD',
    backgroundLight: '#F8F8F8',
    black: '#1D1D1F',
    grayDescription: '#8C8C8C',
    warning: '#EEA345',
    title: '#AAAAAA',
    colorDanger: '#FFE7E7',
    dangerFontColor: '#F00',
    colorWarning: '#FFF0D2',
    warningFontColor: '#FF7300',
    black0: '#000000',
    black05: 'rgba(0, 0, 0, 0.05)',
    black10: 'rgba(0, 0, 0, 0.10)',
    black12: 'rgba(0, 0, 0, 0.12)',
    black14: 'rgba(0, 0, 0, 0.14)',
    black15: 'rgba(0, 0, 0, 0.15)',
    black20: 'rgba(0, 0, 0, 0.20)',
    black25: 'rgba(0, 0, 0, 0.25)',
    black35: 'rgba(0, 0, 0, 0.35)',
    black54: 'rgba(0, 0, 0, 0.54)',
    black75: 'rgba(0, 0, 0, 0.75)',
    black87: 'rgba(0, 0, 0, 0.87)',
    softShadow: 'rgba(0, 0, 0, 0.04)',
    veryLightGray: '#E0E0E0',
    veryLightBlack: 'rgba(0, 0, 0, 0.05)',
    snowWhite: '#FBFBFB',
    cultured: '#f4f4f4',
    ghostWhite: '#f9f9f9',
    grayBorder: '#D4D4D4',
    scrollBar: '#DDD',
    flashWhite: '#F3F3F3',
    whiteSmoke: '#F2F2F2',
    lightSilver: '#d9d9d9',
    cultured7: '#f7f7f7',
    lotion: '#FAFAFA',
    whisper: '#E9E9E9',
    pending: '#FF9330',
    shadedWhite: '#EFEFEF',
    silver: '#B2B2B2',
    dimGray: '#656565',
    defaultPrimary: '#56CCF2',
    mistyRose: '#FFE1E1',
    cornSilk: '#FFF7DD',
    darkSilver: '#CFCFCF',
    romanSilver: '#848E97',
    lavenderGray: '#C2CACC',
    platinum: '#E5E5E5',
    ivoryMist: '#FEFEFE',
    vividOrange: '#FF9800',
    peachPuff: '#FEF5E5',
    warmYellow: '#FFD557',
    linen: '#FFECEC',
    coral: '#FDA2A3',
    soapStone: '#fcfcfc',
    chineseSilver: '#c7c7c7',
    gray: '#7C7C7C',
    grayGoose: '#D2D2D2',
    blue2: '#2F80ED',
    crayola: '#50AD55',
    silver: '#bdbdbd',
    festival: '#F2C94C',
    dodgerBlue: '#1e88e5',
    grey80: '#808080',
    raisinBlack: '#222222',
    graniteGrey: '#656565',
    pastalSilver: '#DCDBDC',
    indeigo: '#5C6BC0',
    periWinkle: '#9FA8DA',
    blueGray: '#7986CB',
    greyOfWhite: '#F0F0F0',
    coralRed: '#FF5151',
    lavenderBlush: '#FFECEC',
    darkRed: '#FF1616',
    whiteSmoke: '#F6F6F6',
    whisperGray: '#ECECEC',
    semiTransparentBlack: '#000000BF',
    dimGrey: '#616161'
};
const theme = (primaryColor = '#56CCF2', secondaryColor = '#455157') => {
    return (0, styles_1.createTheme)({
        //@ts-ignore
        listIconWidth: 43,
        palette: {
            primary: {
                main: primaryColor,
            },
            secondary: {
                main: secondaryColor,
            },
            grey: {
                50: '#f8f8f8',
                100: '#f5f5f5',
                200: '#eeeeee',
                300: '#e0e0e0',
                400: '#bdbdbd',
                500: '#9e9e9e',
                600: '#757575',
                700: '#616161',
                800: '#424242',
                900: '#212121',
            },
            error: {
                main: exports.colors.danger,
                contrastText: exports.colors.white,
            },
            success: {
                main: exports.colors.success,
                contrastText: exports.colors.white,
            },
        },
        typography: {
            h1: {
                fontSize: 24,
            },
            h2: {
                fontSize: 20,
            },
            h3: {
                fontSize: 16,
            },
            h4: {
                fontSize: 14,
                lineHeight: 'normal',
            },
            h5: {
                fontSize: 12,
            },
            fontFamily: ['"Roboto"', '"Helvetica"', '"Arial"', 'sans-serif'].join(','),
        },
        overrides: {
            MuiListItem: {
                root: {
                    '&:hover': {
                        color: 'unset',
                    },
                },
            },
            MuiTypography: {
                h3: {
                    color: 'unset',
                },
            },
            MuiListItemText: {
                root: {
                    padding: '0 5px',
                },
            },
            MuiInputAdornment: {
                positionStart: {
                    marginRight: '4px',
                },
            },
            MuiSelect: {
                select: {
                    '&:focus': {
                        backgroundColor: 'none',
                    },
                },
            },
            MuiAppBar: {
                colorDefault: {
                    backgroundColor: exports.colors.white,
                },
            },
            MuiFormLabel: {
                root: {
                    '& .MuiFormLabel-asterisk': {
                        display: 'none',
                    },
                },
            },
        },
    });
};
exports.theme = theme;
//# sourceMappingURL=theme.js.map